import { momentToDateFns } from 'utils'

export default (format) => momentToDateFns(format) || 'MMMM do yyyy'
